const frenchCountries = ['FR','GF','PF','TF'];

export default frenchCountries;